import React from "react";
import Select from "../../../../form/select/Select";

const TextOptions = ({ editor }) => {
  const formattingOptions = [
    { name: "Normal", value: "normal", icon: "fa fa-paragraph" },
    { name: "Heading 1", value: 1, icon: "fas fa-heading" },
    { name: "Heading 2", value: 2, icon: "fas fa-heading" },
    { name: "Heading 3", value: 3, icon: "fas fa-heading" },
    { name: "Heading 4", value: 4, icon: "fas fa-heading" },
    { name: "Heading 5", value: 5, icon: "fas fa-heading" },
    { name: "Heading 6", value: 6, icon: "fas fa-heading" },
    { name: "Code Block", value: "codeBlock", icon: "fas fa-file-code" },
  ];

  function getActiveFormat() {
    const headingLevel = [1, 2, 3, 4, 5, 6].find((level) =>
      editor.isActive("heading", { level })
    );
    if (headingLevel) return headingLevel;
    if (editor.isActive("paragraph")) return "normal";
    if (editor.isActive("codeBlock")) return "codeBlock";
    return "normal";
  }

  function onChangeHandler(val, data) {
    editor.chain().focus();

    if ([1, 2, 3, 4, 5, 6].includes(val)) {
      editor.chain().toggleHeading({ level: val }).run();
    } else {
      switch (val) {
        case "normal":
          editor.chain().setParagraph().run();
          break;
        case "bulletList":
          editor.chain().toggleBulletList().run();
          break;
        case "orderedList":
          editor.chain().toggleOrderedList().run();
          break;
        case "taskList":
          editor.chain().toggleTaskList().run();
          break;
        case "blockquote":
          editor.chain().toggleBlockquote().run();
          break;
        case "codeBlock":
          editor.chain().toggleCodeBlock().run();
          break;
        default:
          break;
      }
    }
  }

  return (
    <Select
      dropdownButtonClass={"h-9"}
      dropdownData={formattingOptions}
      checked={false}
      onChange={onChangeHandler}
      selectedValue={getActiveFormat()}
    />
  );
};

export default TextOptions;
